import { all, call, put, select, takeLatest } from "redux-saga/effects";
import * as jsonpatch from "fast-json-patch";
import cloneDeep from "lodash.clonedeep";
import { FETCH_AGENT_RECOMMENDATIONS, fetchAgentRecommendations, fetchAgentRecommendationsSuccess, fetchAgentRecommendationsRequested, fetchAgentRecommendationsFailure, UPDATE_AGENT_RECOMMENDATIONS, updateAgentRecommendationsFailure, updateAgentRecommendationsRequested } from "../actions/agent-recommendations-action-types";
import httpClient from "./http-client";
import { toggleSnackBar } from "../actions/app-action-types";

export function* fetchAgentRecommendationHandler() {
  yield put(fetchAgentRecommendationsRequested());
  const agent = yield select((state) => state?.user?.user?.identifier);
  const request = {
    method: "GET",
    url: `/api/v1/agent-recommendation/${agent}`,
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(fetchAgentRecommendationsFailure(data));
  } else {
    yield put(fetchAgentRecommendationsSuccess(data.details));
  }
}

export function* updateAgentRecommendationLockHandler({ payload }) {
  yield put(updateAgentRecommendationsRequested());
  const recommendations = yield select((state) => state?.agentRecommendation?.recommendation);
  const updatedRecommendations = cloneDeep(recommendations);

  const response = yield all(
    payload.map((payload) => {
      payload = {
        ...payload,
        locked: false,
      };

      const singleRecommendation = updatedRecommendations.find((recommendation) => recommendation.identifier === payload.identifier);
      const updates = {
        ...singleRecommendation,
        ...payload,
      };

      const diffPayload = jsonpatch.compare(singleRecommendation, updates);

      if (diffPayload.length) {
        const request = {
          data: { payload: diffPayload },
          method: "PATCH",
          url: `/api/v1/agent-recommendation/${payload.identifier}`,
        };

        return call(httpClient, request, true);
      }
    }),
  );

  let error = false;

  response.forEach((res) => {
    if (!res || res.error) {
      error = true;
    }
  });

  const options = {
    message: "Unlocked successfully",
    severity: "success",
  };

  if (error) {
    yield put(toggleSnackBar(error?.response?.data?.details || "Something went wrong."));
    yield put(updateAgentRecommendationsFailure(error));
  } else {
    yield put(fetchAgentRecommendations());
    yield put(toggleSnackBar(options));
  }
}

function* AgentRecommendation() {
  yield all([
    takeLatest(FETCH_AGENT_RECOMMENDATIONS, fetchAgentRecommendationHandler), takeLatest(UPDATE_AGENT_RECOMMENDATIONS, updateAgentRecommendationLockHandler),
  ]);
}

export default AgentRecommendation;
